module.exports = "/dist/de984c02ef9e756eceb2afbb2257425a.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-900.woff
// module id = 164
// module chunks = 0